import { Button, Checkbox, Input, message, Space } from 'antd'
import { useToken } from 'app/hooks'
import { set } from 'lodash'
import React from 'react'
import { View } from 'styles/reactnative'
import useSWR from 'swr'
import API from 'utils/api'

const GSlipage = ({ group_id, ep_id }) => {
	const { data: token } = useToken()

	const [force, setForce] = React.useState<any>(0)
	const [max, setMax] = React.useState<any>(1000)

	const [show, setShow] = React.useState<any>(true)

	const { data, mutate } = useSWR(`/admin/slip/gslip?group_id=*&ep_id=*`, async url => {
		const res = await API.get(url, token + '', {}, false).then(
			res => res?.result
		)
		return res || []
	})

	React.useEffect(() => {
		if (data?.result) {
			const find = data?.result?.find(i => i.ep_id == ep_id && i.group_id == group_id)?.value
			if (find) {
				const split = find.split(':')
				setForce(split[0])
				setMax(split[1])
				setShow(+split[2] == 1 ? true : false)
			}
		}
	}, [data])

	return (
		<Space style={{ width: '100%', padding:0, gap:0, fontSize:11, whiteSpace:'nowrap' }} size={'small'} direction="horizontal">
		  노출
		<Checkbox checked={show} onChange={e => setShow(e.target.checked)} />
			{' '}
			강제
			<Input
				value={force}
				onChange={e => setForce(e.target.value)}
				type="number"
				max={1000}
				min={0}
				style={{ width: 60, fontSize: 10, background: force > 0 ? '#ffdddd' : 'white'  }}
			/>{' '}
			최대
			<Input
				value={max}
				onChange={e => setMax(e.target.value)}
				type="number"
				max={1000}
				min={0}
				style={{ width: 60, fontSize: 10, background: max > 1000 ? '#ffdddd' : 'white' }}
			/>
			<Button
				type="primary"
				onClick={() => {
					API.post(`/admin/slip/gslip`, token + '', {
						group_id,
						ep_id,
						force,
						max,
						show: show ? 1 : 0
					}).then(res => {
						message.success('적용되었습니다.')
						mutate();
					})
				}}
				size="small">
				반영
			</Button>
			<Button
				type="primary"
				onClick={() => {
					API.post(`/admin/slip/gslip`, token + '', {
						group_id,
						ep_id,
						force:0,
						max:0,
						show:0
					}).then(res => {
						message.success('삭제되었습니다.')
						mutate();
					})
				}}
				size="small">
				삭제
			</Button>
		</Space>
	)
}

export default React.memo(GSlipage)
